import type { LiquidityReport } from 'api/portfolio';

import { createReportSlice } from './reportStore';

const initialFilters = {
  client: '',
  strategy: '',
  institute: '',
  account: '',
  advisor: '',
};

const slice = createReportSlice<LiquidityReport>(
  'operationLiquidity',
  initialFilters,
);

export default slice.reducer;
